import { DemandeValidationPjStatutBackOfficeEnum } from '@graphql/generated';
import { DemandeValidationPjStatutBackOffice } from '@lib/models/demande-validation-pj/types/demande-validation-pj-statut.type';

export class DemandeValidationPjStatutBackOfficeMapper {
  public static toGraphQl(
    input: DemandeValidationPjStatutBackOffice | null
  ): DemandeValidationPjStatutBackOfficeEnum | undefined {
    const mapping: Record<
      DemandeValidationPjStatutBackOffice,
      DemandeValidationPjStatutBackOfficeEnum
    > = {
      a_affecter: DemandeValidationPjStatutBackOfficeEnum.AAffecter,
      a_controler: DemandeValidationPjStatutBackOfficeEnum.AControler,
      nc_traitee: DemandeValidationPjStatutBackOfficeEnum.NcTraitee,
      annule: DemandeValidationPjStatutBackOfficeEnum.Annule,
      expire: DemandeValidationPjStatutBackOfficeEnum.Expire,
      nc_a_traiter: DemandeValidationPjStatutBackOfficeEnum.NcATraiter,
      refuse: DemandeValidationPjStatutBackOfficeEnum.Refuse,
      controle_en_cours: DemandeValidationPjStatutBackOfficeEnum.ControleEnCours,
      valide: DemandeValidationPjStatutBackOfficeEnum.Valide,
      validation_en_cours: DemandeValidationPjStatutBackOfficeEnum.ValidationEnCours,
      en_signature: DemandeValidationPjStatutBackOfficeEnum.EnSignature,
      relance: DemandeValidationPjStatutBackOfficeEnum.Relance,
    };
    return input ? mapping[input] : undefined;
  }

  public static fromGraphQl(
    input: DemandeValidationPjStatutBackOfficeEnum | null | undefined
  ): DemandeValidationPjStatutBackOffice {
    const mapping: Record<
      DemandeValidationPjStatutBackOfficeEnum,
      DemandeValidationPjStatutBackOffice
    > = {
      A_AFFECTER: 'a_affecter',
      A_CONTROLER: 'a_controler',
      CONTROLE_EN_COURS: 'controle_en_cours',
      NC_TRAITEE: 'nc_traitee',
      ANNULE: 'annule',
      EXPIRE: 'expire',
      NC_A_TRAITER: 'nc_a_traiter',
      REFUSE: 'refuse',
      VALIDE: 'valide',
      VALIDATION_EN_COURS: 'validation_en_cours',
      EN_SIGNATURE: 'en_signature',
      RELANCE: 'relance',
    };
    return input ? mapping[input] : 'a_affecter';
  }
}
